import { useContext, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import Container from "@mui/material/Container";
import Button from "@mui/material/Button";

import Logoredcom from "../../img/logoredcomp.png";
import { RenderContext } from "../../Context/RenderContext";

function Header() {
  const { handleMenu, pages } = useContext(RenderContext);

  return (
    <AppBar position="static" style={{ background: "#ccd6e1" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Card
            sx={{
              background: "#ccd6e1",
              border: "none",
              display: { xs: "none", md: "block" },
            }}
          >
            <CardContent>
              <CardMedia
                sx={{
                  background: "#ccd6e1",
                  width: { xs: "100%", md: "100%", lg: "100%" },
                  height: { xs: 30, md: 50, lg: 100 },
                }}
                component="img"
                src={Logoredcom}
                alt="redcomp"
              />
            </CardContent>
          </Card>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}>
            {pages.map((page, index) => (
              <Button
                key={page}
                id={"m" + index}
                onClick={handleMenu}
                sx={{
                  my: 1,
                  flexGrow: 1,
                  fontSize: { xs: 9, md: 16 },
                  fontFamily: "monospace",
                  fontWeight: "bold",
                  color: "#373e46",
                  display: "block",
              
                }}
              >
                <p id={"m" + index}> {page}</p>
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
